import API from "./api";
import { URL } from "./URL";

export const postRegisterWithoutOrg = (user) => {
	return API.post(URL.REGISTRATION.WITHOUT_ORG, user);
};

export const postRegisterWithOrg = (user) => {
	return API.post(URL.REGISTRATION.WITH_ORG, user);
};